import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class QRangeInputs extends TS_EditableItemComponent {
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.disabled = nextProps.disabled ?? false;
        state.divider = nextProps.divider;
        state.array = nextProps.editable.editProp(nextProps.prop, [0, 0]);
        return state;
    }
    // ######################### Logic #########################
    onValueChange = async (value, index) => {
        await this.state.array.updateArrayAt(value, index);
    };
    // ######################### Render #########################
    render() {
        const editable = this.state.array;
        return _jsxs(LL_H_C, { className: 'q-range-inputs', children: [_jsx(TS_Input, { type: 'number', value: editable.item[0], onBlur: value => this.onValueChange(Number(value), 0) }), this.state.divider && _jsx("div", { className: 'q-range-inputs__divider', children: this.state.divider }), _jsx(TS_Input, { type: 'number', value: editable.item[1], onBlur: value => this.onValueChange(Number(value), 1) })] });
    }
}
//# sourceMappingURL=QRangeInputs.js.map